__turbopack_context__.v({
  "activeCategory": "workbench-document-menu-module__B2LHfW__activeCategory",
  "categories": "workbench-document-menu-module__B2LHfW__categories",
  "category": "workbench-document-menu-module__B2LHfW__category",
  "document": "workbench-document-menu-module__B2LHfW__document",
  "dropdown": "workbench-document-menu-module__B2LHfW__dropdown",
  "expandedIcon": "workbench-document-menu-module__B2LHfW__expandedIcon",
  "lockedHint": "workbench-document-menu-module__B2LHfW__lockedHint",
  "navigation": "workbench-document-menu-module__B2LHfW__navigation",
});
